import { useMutation, useQueryClient } from "@tanstack/react-query";
import { patchDraftAction, PatchDraftPayload } from "../actions/patchDraft.actions";
import { fileToDataUrl } from "../../editor/project/helpers/file-to-data-url.helpers";

export function usePatchDraftMutation() {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: async ({ draftId, payload }: { draftId: string; payload: PatchDraftPayload }) =>


            patchDraftAction(draftId, payload),

        onSuccess: (updatedDraft, vars) => {
        },
    });
}
